import { FC, useCallback, useEffect, useMemo } from "react";
import { Organization, SelectOption } from "../../utils/models";

import { getOrganizations, loadOrganizations } from "../../store/organizations";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";

function withOrganizations(Component: any): FC<any> {
  return function WithOrganizations(props): JSX.Element {
    const dispatch = useAppDispatch();
    const organizations = useAppSelector(getOrganizations);

    const activeOrganizations = useMemo(() => {
      const allOrganizations: Organization[] = organizations.organizations;
      return allOrganizations ? allOrganizations.filter((organization) => organization.isActive) : [];
    }, [organizations.organizations]);

    const organizationsForDropdown = useMemo((): SelectOption[] => {
      return activeOrganizations.map((organization) => ({
        id: organization._id,
        name: organization.organisationName,
      }));
    }, [activeOrganizations]);

    const activeOrganizationsWithFacilities = useMemo(() => {
      const activeOrganizationsWithFacilities = activeOrganizations.map((organization) => ({
        ...organization,
        facilities: organization.facilities.filter((facility) => facility.isActive)
      }));

      return activeOrganizationsWithFacilities;
    }, [activeOrganizations]);

    const refreshOrganizations = useCallback(() => {
        dispatch(loadOrganizations() as any);
    }, [dispatch]);

    useEffect(() => {
      refreshOrganizations();
    }, [refreshOrganizations]);

    return (
      <Component
        organizations={activeOrganizationsWithFacilities}
        organizationsForDropdown={organizationsForDropdown}
        organizationsLoading={organizations.loading}
        organizationsError={organizations.error}
        refreshOrganizations={refreshOrganizations}
        organizationsLastUpdated={organizations.lastUpdated}
        {...props}
      />
    );
  };
}

export default withOrganizations;
